import { sqliteTable, text, integer, index, type AnySQLiteColumn } from "drizzle-orm/sqlite-core";

// ============================================================================
// cost_centers — ศูนย์ต้นทุน / แผนก (Cost Center / Department) — tree structure
// ============================================================================
export const costCenters = sqliteTable("accounting_cost_centers", {
  id: text("id").primaryKey(), // ULID
  companyId: text("company_id").notNull(),
  code: text("code").notNull(),
  name: text("name").notNull(),
  parentId: text("parent_id").references((): AnySQLiteColumn => costCenters.id), // self-ref tree
  isGroup: integer("is_group").notNull().default(0),
  isActive: integer("is_active").notNull().default(1),
  createdBy: text("created_by"),
  createdAt: text("created_at").notNull(),
  updatedBy: text("updated_by"),
  updatedAt: text("updated_at").notNull(),
  deletedBy: text("deleted_by"),
  deletedAt: text("deleted_at"),
}, (table) => ({
  cc_company_idx: index("cc_company_idx").on(table.companyId, table.isActive),
  cc_parent_idx: index("cc_parent_idx").on(table.parentId),
}));

// Type exports
export type CostCenter = typeof costCenters.$inferSelect;
export type NewCostCenter = typeof costCenters.$inferInsert;
